export default class Popup {
    constructor() {
        this.backdrop = 'static';
    }
    open(data) {
        this.hide();
        this.$scope = this.$rootScope.$new(true);
        Object.assign(this.$scope, data);
        this.modal = this.$modal({
            id: 'popup',
            scope: this.$scope,
            backdrop: this.backdrop,
            contentTemplate: this.contentTemplateUrl,
        });
    }
    isOpen() {
        return this.modal && this.modal.$isShown;
    }
    hide() {
        if (this.modal)
            this.modal.hide();
    }
}
